import { memo } from "react";
import { WebRoutes } from "consts/enpoints/web";
import { ECommerceOnboardingApplication } from "consts/onboarding";
import { ApplicationDetail } from "ui/organizms/Onboarding/Applications/common";
import {
    BusinessInformationLabel,
    BankingAndFinanceLabel,
    MediaAndComplianceCheckLabel,
    UBOIdentityVerificationLabel,
    PaymentMethodsLabel
} from "./steps";
import {
    getECommerceBillingFinanceSteps,
    getECommerceBusinessInformationSteps,
    getECommerceIdentityVerificationSteps,
    getECommerceMediaComplianceSteps,
    getECommercePaymentMethodsSteps
} from "features/onboarding/api";

const ECommerceApplicataion = () => (
    <ApplicationDetail
        name='E-Commerce'
        href={WebRoutes.Onboarding.Applications.ECommerce}
        steps={new Map()
            .set(ECommerceOnboardingApplication.BusinessInformation, {
                totalStepFields: 8,
                fetcher: getECommerceBusinessInformationSteps
            })
            .set(ECommerceOnboardingApplication.BillingFinance, {
                totalStepFields: 9,
                fetcher: getECommerceBillingFinanceSteps
            })
            .set(ECommerceOnboardingApplication.MediaCompliance, {
                totalStepFields: 8,
                fetcher: getECommerceMediaComplianceSteps
            })
            .set(ECommerceOnboardingApplication.IdentityVerification, {
                totalStepFields: 7,
                nestedEntityFiled: 'uboIdentities',
                fetcher: getECommerceIdentityVerificationSteps
            })
            .set(ECommerceOnboardingApplication.PaymentMethods, {
                totalStepFields: 1,
                fetcher: getECommercePaymentMethodsSteps
            })}
    >
        <BusinessInformationLabel />
        <BankingAndFinanceLabel />
        <MediaAndComplianceCheckLabel />
        <UBOIdentityVerificationLabel />
        <PaymentMethodsLabel />
    </ApplicationDetail>
);

export default memo(ECommerceApplicataion);
